/* eslint-disable no-console */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const restclient = require('nordic/restclient');
const TextField = require('@andes/textfield');
const Button = require('@andes/button');
const { Portal } = require('@andes/common');
const ProgressIndicatorCircular = require('@andes/progress-indicator-circular');
const ContactSuccess = require('./images/ContactSuccess');
const ContactError = require('./images/ContactError');

const request = restclient(
  {
    baseURL: '/developers/api',
    timeout: 5000,
  },
);

function Contact(props) {
  const { i18n, userData, email, lang, platform, isContactSuscribed } = props;
  const { useState } = React;
  const showContactLogged = userData && userData.id !== null && userData.id !== undefined;

  const [showContactInput, setShowContactInput] = useState(true);
  const [contactSubmitResult, setContactSubmitResult] = useState(null);
  const callbackUrl = `https://www.${platform.domain}/developers/${lang}/guides%23contact-form`;
  const defaultEmail = isContactSuscribed ? '' : email;

  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [valueMail, setValueMail] = useState(defaultEmail);
  const [modifierEmail, setModifierEmail] = useState('default');
  const [messageValidate, setMessageValidate] = useState('');

  function submitContact() {
    setSpinnerVisible(false);
    request.post('/contact', {
      data: {
        lang,
        developer_email: valueMail,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        // muestro el success
        if (response.status === 202) {
          setContactSubmitResult('success-optin');
        } else {
          setContactSubmitResult('success');
        }
        setShowContactInput(false);
        setSpinnerVisible(false);
      })
      .catch(() => {
        // muestro el fail
        setContactSubmitResult('error');
        setShowContactInput(false);
        setSpinnerVisible(false);
      });
  }

  function regexValidate(text) {
    const regexURL = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    // eslint-disable-next-line security/detect-unsafe-regex
    return text.match(regexURL);
  }

  function validateMail() {
    if (regexValidate(valueMail)) {
      submitContact();
    } else {
      setModifierEmail('invalid');
      setMessageValidate(i18n.gettext('Revisa este dato'));
    }
  }

  return (
    <div className="home-contact" id="contact-form">
      { showContactInput && showContactLogged && (
      <div className="home-contact__content">
        <div className="home-contact__text">
          <div className="contact-title">{i18n.gettext('Novedades para desarrolladores')}</div>
          <div className="contact-subtitle">{i18n.gettext('Recibe información técnica y mantente al tanto de nuestras actualizaciones')}.</div>
        </div>
        <div className="home-contact__input">
          <TextField
            className="home-contact__email"
            name="contact-email"
            placeholder={i18n.gettext('E-mail')}
            textbox
            onChange={(event) => setValueMail(event.target.value)}
            defaultValue={defaultEmail}
            helper={i18n.gettext(messageValidate)}
            modifier={modifierEmail}
          />
          <Button
            className="home-contact__button"
            hierarchy="loud"
            onClick={() => validateMail()}
          >
            {i18n.gettext('Suscribirme')}
          </Button>
        </div>
      </div>
      )}
      { showContactInput && !showContactLogged && (
      <div className="home-contact__content">
        <div className="home-contact__text">
          <div className="contact-title">{i18n.gettext('Novedades para desarrolladores')}</div>
          <div className="contact-subtitle">
            <div className="contact-subtitle-text">
              <a className="contact-login" href={`https://www.mercadolibre.com/jms/${platform.siteId.toLowerCase()}/lgz/login?platform_id=mp&amp;go=${callbackUrl}`}>{i18n.gettext('Ingresa')} </a> {i18n.gettext('o')} <a className="contact-login" href={`https://registration.${platform.domain}/registration-mp?confirmation_url=${callbackUrl}`}> {i18n.gettext('regístrate')} </a> {i18n.gettext('para recibir información sobre novedades técnicas')}.
            </div>
          </div>
        </div>
        <div className="home-contact__input" />
      </div>
      )}

      { contactSubmitResult === 'success' && (
      <div className="home-contact__content">
        <div className="contact-icon">
          <ContactSuccess />
        </div>
        <div className="home-contact__text">
          <div className="contact-title">{i18n.gettext('¡Suscripción Exitosa!')}</div>
          <div className="contact-subtitle">
            <div className="contact-subtitle-text">
              {i18n.gettext('Pronto recibirás novedades técnicas e información útil para desarrolladores')}.
            </div>
          </div>
        </div>
        <div className="home-contact__input" />
      </div>
      )}
      { contactSubmitResult === 'success-optin' && (
      <div className="home-contact__content">
        <div className="contact-icon">
          <ContactSuccess />
        </div>
        <div className="home-contact__text">
          <div className="contact-title">{i18n.gettext('¡Excelente!')}</div>
          <div className="contact-subtitle">
            <div className="contact-subtitle-text">
              {i18n.gettext('Solo un paso más, revisa tu e-mail para confirmar tu suscripción')}.
            </div>
          </div>
        </div>
        <div className="home-contact__input" />
      </div>
      )}
      { contactSubmitResult === 'error' && (
      <div className="home-contact__content">
        <div className="contact-icon">
          <ContactError />
        </div>
        <div className="home-contact__text">
          <div className="contact-title-error">{i18n.gettext('Ocurrió un error y no pudimos guardar este dato')}</div>
          <div className="contact-subtitle-error">
            <div className="contact-subtitle-text">
              {i18n.gettext('Vuelve a intentarlo más tarde.')}
            </div>
          </div>
        </div>
        <div className="home-contact__input" />
      </div>
      )}
      {spinnerVisible && (
        <Portal>
          <ProgressIndicatorCircular
            size="large"
            modifier="fullscreen"
          />
        </Portal>
      )}
    </div>
  );
}

Contact.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
};

Contact.defaultProps = {
  i18n: { gettext: () => {} },
};

module.exports = Contact;
